// extracted by mini-css-extract-plugin
export default {"featherInbox":"EmptyState_featherInbox__rKMx6","noCustomersAvailableText":"EmptyState_noCustomersAvailableText__NISDW"};